var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBabyBoyDress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.947 7.003s-2.264 2.249-2.93 1.974C1.077 8.588.67 4.82 1.31 4.245l2.457-2.212C4.9 1.01 4.93 1 6.439 1h1.518C8.184 2.36 9.496 3.992 11 3.992c1.504 0 2.816-1.633 3.043-2.992h1.519c1.507 0 1.537.011 2.671 1.033l2.457 2.212c.64.575.233 4.343-.707 4.732-.666.275-2.934-1.974-2.934-1.974",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6v10.527c0 .705.12 1.082.755 1.423 2.613 1.4 7.877 1.4 10.49 0 .635-.34.755-.718.755-1.423V6M5 8c2 2.667 10 2.667 12 0",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconBabyBoyDress;